import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("owner@autostore.ai");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/login", { email, password });
      // Backend sets the `owner_token` httpOnly cookie; nothing stored client-side.
      nav("/admin");
    } catch {
      setErr("Invalid credentials.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dash flex items-center justify-center px-6">
      <form onSubmit={submit} className="dash-card w-full max-w-md p-8">
        <div className="flex items-center gap-2 mb-2">
          <span className="ai-dot" />
          <div className="label-mono" style={{ color: "rgba(255,255,255,0.5)" }}>/ MERIDIAN PRESS · MISSION CONTROL</div>
        </div>
        <h1 className="font-display text-4xl font-medium tracking-tight mb-6">Sign in.</h1>
        <label className="block mb-3">
          <span className="label-mono text-white/60">Email</span>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="dash-input mt-2" required />
        </label>
        <label className="block mb-4">
          <span className="label-mono text-white/60">Password</span>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="dash-input mt-2" required />
        </label>
        {err && <div className="text-sm text-[#FF3B30] font-mono-ui mb-3">{err}</div>}
        <button data-testid="login-submit" type="submit" disabled={busy} className="dash-btn w-full">{busy ? "Signing in…" : "Enter →"}</button>
        <p className="mt-4 text-xs text-white/40 font-mono-ui">Default: owner@autostore.ai / AutoStore2026</p>
      </form>
    </div>
  );
}
